import { useContext } from 'react';
import { DialogContext } from '../contexts';

export const useDialog = () => {
  const ctx = useContext(DialogContext);

  return ctx;
};
